import { createFileRoute } from "@tanstack/react-router";
import { RolesPage } from "@/components/roles";
import { requirePermission } from "@/lib/casl/route-guards";

export const Route = createFileRoute("/_authenticated/roles/")({
  component: RolesPage,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "roles");
  },
});
